import React from "react";
import Layout from "../../components/web/Layout";
import Container from "../../components/ui/container/Container";
import BreadCrump from "../../components/web/breadcrump/BreadCrump";
import { IoCloseSharp } from "react-icons/io5";
import { formatToINR, getFileUrl } from "../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, removeFromWishlist } from "../../store/slice/userActions";
import toast from "react-hot-toast";
import placeHolderImage from "../../assets/images/placeholder/product.jpg";
import UserPartnerAuth from "../../middleware/UserPartnerAuth";
const Wishlist = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.user.loading);
  const wishlist = useSelector((state) => state.user.wishlist);
  const removeItem = (id) => {
    dispatch(removeFromWishlist(id));
  };
  const handleAddToCart = async (productId) => {
    try {
      await dispatch(addToCart({ productId, quantity: 1, type: "I" })).unwrap();
      toast.success("Added to cart");
    } catch (err) {
      toast.error(String(err) || "Failed to add to cart");
    }
  };
  return (
    <UserPartnerAuth>
      <Layout>
        <BreadCrump />
        <Container>
          <h2 className="my-4 text-2xl font-semibold text-center">
            My Wishlist
          </h2>
          <div className="col-span-2 p-4 bg-white">
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border text-[12px] border-gray-200 bg-white">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="p-2 text-left">Product</th>
                    <th className="p-2 text-center">Price</th>
                    <th className="p-2 text-center">Stock</th>
                    <th className="p-2 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    Array.from({ length: 3 }).map((_, index) => (
                      <tr key={index} className="border-b animate-pulse">
                        <td className="flex flex-col items-center gap-3 p-2 text-center sm:flex-row">
                          <div className="w-12 h-12 bg-gray-200 border rounded"></div>
                          <div>
                            <div className="w-24 h-4 mb-1 bg-gray-200 rounded"></div>
                            <div className="w-20 h-3 bg-gray-200 rounded"></div>
                          </div>
                        </td>
                        <td className="p-2 text-center">
                          <div className="flex justify-center">
                            <div className="w-16 h-4 bg-gray-200 rounded"></div>
                          </div>
                        </td>
                        <td className="p-2 text-center">
                          <div className="flex justify-center">
                            <div className="w-16 h-4 bg-gray-200 rounded"></div>
                          </div>
                        </td>
                        <td className="p-2 text-center">
                          <div className="flex justify-center gap-2">
                            <div className="w-16 h-6 bg-gray-200 rounded"></div>
                            <div className="w-6 h-6 bg-gray-200 rounded"></div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (wishlist?.products?.length ?? 0) === 0 ? (
                    <tr>
                      <td colSpan="4" className="p-4 text-center text-gray-500">
                        Your Wishlist is empty. Add items to continue.
                      </td>
                    </tr>
                  ) : (
                    wishlist?.products.map((item, index) => (
                      <tr key={index} className="border-b hover:bg-gray-50">
                        <td className="flex flex-col items-center gap-3 p-2 text-center sm:flex-row">
                          <img
                            src={getFileUrl(
                              item?.product?.image ?? placeHolderImage
                            )}
                            alt={item?.product?.name}
                            className="w-12 h-12 border"
                          />
                          <div>
                            <span className="font-semibold">
                              {item?.product?.name}
                            </span>
                          </div>
                        </td>
                        <td className="p-2 text-nowrap">
                          {formatToINR(item?.product?.finalPrice.toFixed(2))}
                        </td>
                        <td className="p-2 text-nowrap">
                          <span
                            className={`px-2 py-1 text-xs font-semibold rounded bg-green-200 text-green-700 `}
                          >
                            In Stock
                          </span>
                        </td>
                        <td className="p-2 text-center text-nowrap">
                          <div className="flex justify-center gap-2">
                            <button
                              onClick={() =>
                                handleAddToCart(item?.product?._id)
                              }
                              className="px-3 py-1 text-xs text-white transition rounded bg-primaryDark hover:bg-primaryDark"
                            >
                              Add to Cart
                            </button>
                            <button
                              onClick={() => removeItem(item?.product?._id)}
                              className="text-red-500 hover:text-red-700"
                            >
                              <IoCloseSharp size={18} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </Container>
      </Layout>
    </UserPartnerAuth>
  );
};

export default Wishlist;
